/* eslint-disable react-hooks/exhaustive-deps */

import { useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import theme from '../../../../config/theme';
import { getInputs } from '../../../../utils/get-inputs';
import { IAdaptedValues } from '../../../../interfaces/edit-adapted-values';
import { useUpdateFunctional } from './useUpdateFunctional';

interface IUseEditFunctional {
	setCurrentFunctional: React.Dispatch<React.SetStateAction<IAdaptedValues>>;
	currentFunctional: IAdaptedValues;
}

export const useEditFunctional = ({
	currentFunctional,
	setCurrentFunctional,
}: IUseEditFunctional) => {
	const navigate = useNavigate();
	const location = useLocation();
	const idProject = location.state.params.idProject as string;
	const [inputs, setInputs] = useState(getInputs(currentFunctional));

	const { handleUpdateFunctional } = useUpdateFunctional({ setCurrentFunctional });

	const matches = useMediaQuery(theme.breakpoints.down('md'));
	useEffect(() => {
		if (!idProject) navigate(-1);
	}, []);

	const onChangeValue = (name: string, value: string) => {
		setInputs(
			inputs.map((element: any) => {
				if (name === element.id)
					return {
						...element,
						value: value,
					};
				return element;
			})
		);
	};

	const updateFunctional = () => {
		const values = inputs.map((element: any) => {
			return element.value;
		});
		handleUpdateFunctional(currentFunctional.id, { columns: values });
	};

	return {
		matches,
		inputs,
		onChangeValue,
		updateFunctional,
	};
};
